const Background = ({imageDesktop, imageMobile}) => (
    <picture data-slide="1" className="home-vertical-carousel__pic">
        <source media={"(max-width: 767px)"} srcSet={imageMobile} />
        <source media={"(min-width: 768px)"} srcSet={imageDesktop} />
        <img width={700} height={657}  src={imageMobile} />
    </picture>
);

export default Background;
